// ENTITY fr.gestionpial.pial.dto.RemplacementAeshDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class RemplacementAeshDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.RemplacementAeshDTO';

  idAesh: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  volumeDispo: number | null = 0;
  volumeReserve: number | null = 0;
  aeshCo: boolean | null = false;

  constructor(init?:Partial<RemplacementAeshDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.RemplacementAeshDTO'] = RemplacementAeshDTO;

fields['fr.gestionpial.pial.dto.RemplacementAeshDTO']  = {
    idAesh: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    volumeDispo: 'java.lang.Integer',
    volumeReserve: 'java.lang.Integer',
    aeshCo: 'java.lang.Boolean'
};
